import i18next from 'i18next';

// TODO define this titles
i18next.addResources('es_CL', 'PurchaseStatusScreen', {
  goToOrders: 'Ir a mis órdenes'
});
